import { getRetryDelay, logError, logInfo, sleep } from '@utils-global';
import { isRetryableEwsError } from './ewsResponseError';

const MAX_RETRY_ATTEMPTS = 3;

/**
 * Runs an EWS request with a bounded retry so a transient failure doesn't leave
 * a reported mail sitting in the inbox. Permanent SOAP faults (e.g. access
 * denied) are re-thrown immediately; transient ones are retried with backoff.
 */
export const withEwsRetry = async <T>(request: () => Promise<T>): Promise<T> => {
  let attempt = 0;

  for (;;) {
    try {
      // eslint-disable-next-line no-await-in-loop
      return await request();
    } catch (error) {
      if (!isRetryableEwsError(error)) {
        throw error;
      }

      attempt += 1;

      if (attempt > MAX_RETRY_ATTEMPTS) {
        logError('EWS retries exhausted', error);
        throw error;
      }

      logInfo(`EWS retry ${attempt}/${MAX_RETRY_ATTEMPTS}`);
      // eslint-disable-next-line no-await-in-loop
      await sleep(getRetryDelay(attempt));
    }
  }
};
